import { render, staticRenderFns } from "./CollectCompanys.vue?vue&type=template&id=5a142980&scoped=true&"
import script from "./CollectCompanys.vue?vue&type=script&lang=js&"
export * from "./CollectCompanys.vue?vue&type=script&lang=js&"
import style0 from "./CollectCompanys.vue?vue&type=style&index=0&id=5a142980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a142980",
  null
  
)

export default component.exports